import React from 'react'
import { Link } from 'react-router-dom'

export const SupportFreeTrial: React.FC = () => {
    return (
        <>
            <h1 className="font-bold text-white text-2xl mt-6">
                Начните бесплатно и продолжайте с сохранением всех данных
            </h1>
            <div className="w-full card_item card_item_dark !bg-[#1051F5] flex flex-col gap-2">
                <h2 className="!text-2xl">
                    Получить доступ к бесплатной демоверсии на 60 дней
                </h2>
                <div>
                    <Link
                        to=""
                        className="px-4 py-2 text-sm text-black bg-white rounded-full"
                    >
                        Получить демоверсию
                    </Link>
                </div>
            </div>
        </>
    )
}
